

import { $courses } from '../Services';
import { required } from 'vuelidate/lib/validators';
export default {
  data(){return {
    headers: [
      { text: this.$t('modules.courses.create.table.headers.status'), value: 'status' },
      { text: this.$t('modules.courses.create.table.headers.quarter'), value: 'quarterCount', align: 'center' },
      { text: this.$t('modules.courses.create.table.headers.subjects'), value: 'subjectCount', align: 'center' },
      { text: '', value: 'action' }
    ],
    successMessage: {
      title: '¡Precios creados con éxito!',
      actionPrimary: { text: 'Aceptar', callback: () => {this.$router.push('/prices')} }
    },
    checkingCode: false,
  }},
  computed:{
    canCreate() {
      return this.$permissions.portaladministrativo.academic.courses.CREATE
    },
    canUpdate() {
      return this.$permissions.portaladministrativo.academic.courses.UPDATE
    },
    canCreateCourse() {
      return this.canCreate && !this.$v.formValid.$invalid
    },
    changeStatuslabel() {
      return this.newCourses.status
        ? this.$t('modules.courses.create.sectionData.labelEnable')
        : this.$t('modules.courses.create.sectionData.labelDisable');
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.newCourses.name.$anyError) return errors;

      if (!this.$v.newCourses.name.required) errors.push(this.$t('modules.courses.create.validations.nameRequired'));
      return errors;
    },
    codeErrors() {
      const errors = [];
      if (!this.$v.newCourses.code.$anyError) return errors;
      if (!this.$v.newCourses.code.required) errors.push(this.$t('modules.courses.create.validations.codeRequired'));

      if (!this.$v.newCourses.code.checkIfExists && this.$v.newCourses.code.$model.length >= 3) errors.push(this.$t('modules.courses.create.validations.codeExisting'));
      return errors;
    },

    legalDescriptionErrors() {
      const errors = [];
      if (!this.$v.newCourses.legalDescription.$anyError) return errors;

      if (!this.$v.newCourses.legalDescription.required) errors.push(this.$t('modules.courses.create.validations.legalDescriptionRequired'));
      return errors;
    },
    subjectErrors() {
      const errors = [];
      if (!this.$v.newCourses.subject.$anyError) return errors;

      if (!this.$v.newCourses.subject.required) errors.push(this.$t('modules.courses.create.validations.subjectRequired'));
      return errors;
    },
  },
  validations: {
    newCourses: {
      subject: { required},
      isPaid: {},
      isMandatory: {},
      legalDescription: {required},
      status: {required},
      name: {required},
      courseSubDescription: {},
      code: {
        required,
        async checkIfExists(value){
          try{
            if(this.originalCode === value) return true;
            this.checkingCode = true;
            const res = await $courses.checkIfExists(value);
            return !res.data.exists
          } catch {
            return false;
          } finally {
            this.checkingCode = false;
          }
        }
      },
    },
    formValid: ['newCourses']
  },

}
